<template>
  <footer id="footer" class="footer">

    <div class="footer-container">

      <p class="footer-text">
        © {{ currentYear }} {{ footerLocale.rights }}
      </p>

      <!-- <nav class="footer-links">

        <a
          href="#"
          class="footer-link"
        >
          {{ $t("footer.privacy") }}
        </a>

        <a
          href="#"
          class="footer-link"
        >
          {{ $t("footer.terms") }}
        </a>

      </nav> -->

    </div>

  </footer>
</template>

<script setup>


import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { footer } from "@/data/footer"

const { locale } = useI18n()

const footerLocale = computed(() => {

  if (locale.value === "en") {
    return footer.en
  }

  return footer.pt

})

const currentYear = new Date().getFullYear()

</script>

<style scoped>
.footer {
  padding: 20px;
  backdrop-filter: blur(12px);
  background: var(--bg-secondary);
  border-top: 1px solid var(--card-base);
}

.footer-container {
  max-width: 1300px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.footer-text {
  font-size: 14px;
  color: var(--cor-texto-secundario);
  letter-spacing: 1.5px;
}

.footer-links {
  display: flex;
  gap: 50px;
}

.footer-link {
  font-size: 14px;
  text-decoration: none;
  color: var(--cor-texto-secundario);
  transition: opacity 0.3s ease;
  letter-spacing: 1.5px;
}

.footer-link:hover {
  color: var(--cor-texto-principal);
}

@media (max-width:800px) {

  .footer {
    padding: 10px;
  }

  .footer-container {
    width: 100%;
    max-width: 400px;
    gap: 10px;
    justify-content: center;
  }

  .footer-text {
    font-size: 10px;
  }

  .footer-link {
    font-size: 10px;
  }

}
</style>